"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = warn;
exports.warning = warning;
exports.isIconDefinition = isIconDefinition;
exports.normalizeAttrs = normalizeAttrs;
exports.generate = generate;
exports.getSecondaryColor = getSecondaryColor;
exports.normalizeTwoToneColors = normalizeTwoToneColors;
exports.mergeProps = mergeProps;
exports.renderIconDefinitionToSVGElement = renderIconDefinitionToSVGElement;
exports.optionsToAttrsToken = optionsToAttrsToken;
Object.defineProperty(exports, "upperFirst", {
  enumerable: true,
  get: function get() {
    return _upperFirst["default"];
  }
});
exports.pascail = exports.useInsertStyles = exports.svgBaseProps = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _colors = require("@ant-design/colors");

var _insertCss = require("insert-css");

var _iconStyles = require("./asset/icon-styles");

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function later() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    setTimeout(resolve, delay);
  });
}

function warn(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}

function warning(valid, message) {
  warn(valid, "[@h3/icons-tool] ".concat(message));
}

function isIconDefinition(target) {
  return (0, _typeof2["default"])(target) === 'object' && typeof target.name === 'string' && ((0, _typeof2["default"])(target.icon) === 'object' || typeof target.icon === 'function');
}

function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc["class"];
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}

function generate(h, node, key, rootProps) {
  if (!rootProps) {
    return h(node.tag, {
      key: key,
      attrs: _objectSpread({}, normalizeAttrs(node.attrs))
    }, (node.children || []).map(function (child, index) {
      return generate(h, child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return h(node.tag, _objectSpread(_objectSpread({
    key: key
  }, rootProps), {}, {
    attrs: _objectSpread(_objectSpread({}, normalizeAttrs(node.attrs)), rootProps.attrs)
  }), (node.children || []).map(function (child, index) {
    return generate(h, child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}

function getSecondaryColor(primaryColor) {
  // choose the second color
  return (0, _colors.generate)(primaryColor)[0];
}

function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4


var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
exports.svgBaseProps = svgBaseProps;
var cssInjectedFlag = false;

var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _iconStyles.iconStyles;
  later().then(function () {
    if (!cssInjectedFlag) {
      (0, _insertCss.insertCss)(styleStr, {
        prepend: true
      });
      cssInjectedFlag = true;
    }
  });
};

exports.useInsertStyles = useInsertStyles;

function mergeProps() {
  var props = {};

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function () {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    for (var _i = 0, _Object$entries = Object.entries(p); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
          k = _Object$entries$_i[0],
          v = _Object$entries$_i[1];

      props[k] = props[k] || {};

      if ((0, _isPlainObject["default"])(v)) {
        Object.assign(props[k], v);
      } else {
        props[k] = v;
      }
    }
  });
  return props;
}

var defaultColors = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6'
};

function renderAbstractNodeToSVGElement(node, options) {
  var targetAttrs = node.tag === 'svg' ? _objectSpread(_objectSpread({}, node.attrs), options.extraSVGAttrs || {}) : node.attrs;
  var attrsToken = optionsToAttrsToken(targetAttrs);
  var children = (node.children || []).map(function (child) {
    return renderAbstractNodeToSVGElement(child, options);
  }).join('');

  if (children && children.length) {
    return "<".concat(node.tag).concat(attrsToken, ">").concat(children, "</").concat(node.tag, ">");
  }

  return "<".concat(node.tag).concat(attrsToken, " />");
}

function renderIconDefinitionToSVGElement(iconDefinition) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof iconDefinition.icon === 'function') {
    // colorful
    var placeholders = options.placeholders || defaultColors;
    return renderAbstractNodeToSVGElement(iconDefinition.icon(placeholders.primaryColor, placeholders.secondaryColor), options);
  } // fill, stroke


  return renderAbstractNodeToSVGElement(iconDefinition.icon, options);
}

function optionsToAttrsToken(options) {
  var attrs = Object.keys(options).reduce(function (acc, nextKey) {
    var key = nextKey;
    var value = options[key];

    if (value) {
      var token = "".concat(key, "=\"").concat(value, "\"");
      acc.push(token);
    }

    return acc;
  }, []);
  return attrs.length ? ' ' + attrs.join(' ') : '';
} // 驼峰化


var pascail = function pascail(value) {
  return (0, _upperFirst["default"])((0, _camelCase["default"])(value));
};

exports.pascail = pascail;